












import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FaIcon extends Vue {
  @Prop({ required: true })
  value!: string;

  @Prop() fas: string | boolean | undefined;

  @Prop() far: string | boolean | undefined;

  @Prop() fal: string | boolean | undefined;

  get vHtml() {
    let icon = this.value;

    // custom logos
    if (icon.startsWith("icon-")) {
      return icon;
    }

    if (!icon.startsWith("fa-")) {
      icon = `fa-${icon}`;
    }

    return `${this.type} ${icon}`;
  }

  get type() {
    if (this.isTrue(this.fas)) return `fas`;
    if (this.isTrue(this.far)) return `far`;
    if (this.isTrue(this.fal)) return `fal`;
    return `fal`;
  }

  isTrue(val: string | boolean | undefined) {
    if (typeof val === "boolean") return val;
    if (val === "" || val === "true") return true;
    return false;
  }
}
